export function initNotiserLoadMore(): void {
  const loadMoreBtn = document.getElementById('notiser-load-more')
  if (!loadMoreBtn) {
    return
  }

  const container = document.getElementById('notiser-container')
  if (!container) {
    return
  }

  const wrapper = document.getElementById('notiser-load-more-wrapper')
  if (!wrapper) {
    return
  }

  let currentPage = parseInt(loadMoreBtn.dataset.currentPage || '1', 10)
  const maxPages = parseInt(loadMoreBtn.dataset.maxPages || '1', 10)
  const archiveUrl = loadMoreBtn.dataset.archiveUrl || window.location.pathname

  let isLoading = false

  const updateButtonState = (loading: boolean) => {
    isLoading = loading

    if (loading) {
      loadMoreBtn.setAttribute('disabled', 'true')
      loadMoreBtn.setAttribute('aria-busy', 'true')
      loadMoreBtn.textContent = 'Laddar...'
    } else {
      loadMoreBtn.removeAttribute('disabled')
      loadMoreBtn.removeAttribute('aria-busy')
      loadMoreBtn.textContent = 'Läs in fler notiser'
    }
  }

  const hideButton = () => {
    wrapper.style.display = 'none'
  }

  const loadMorePosts = async () => {
    if (isLoading || currentPage >= maxPages) {
      return
    }

    updateButtonState(true)
    currentPage++

    try {
      const url = new URL(archiveUrl)
      url.pathname = url.pathname.replace(/\/$/, '') + `/page/${currentPage}/`

      const response = await fetch(url.toString(), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const html = await response.text()

      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')
      const newPosts = doc.querySelectorAll('.notiser-item')

      if (newPosts.length === 0) {
        throw new Error('Inga fler notiser att ladda')
      }

      newPosts.forEach((post, index) => {
        const clonedPost = post.cloneNode(true) as HTMLElement
        clonedPost.style.opacity = '0'
        container.appendChild(clonedPost)

        setTimeout(() => {
          clonedPost.style.transition = 'opacity 0.3s ease-in-out'
          clonedPost.style.opacity = '1'
        }, index * 50)
      })

      updateButtonState(false)

      if (currentPage >= maxPages) {
        hideButton()
      }

      loadMoreBtn.dataset.currentPage = currentPage.toString()
    } catch (error) {
      console.error('Failed to load more posts:', error)
      updateButtonState(false)
      loadMoreBtn.textContent = 'Försök igen'

      currentPage--
    }
  }

  loadMoreBtn.addEventListener('click', (e) => {
    e.preventDefault()
    loadMorePosts()
  })
}
